import ReactDOM from 'react-dom';

export const changeStandardPaginationUi = ({
  isMobile,
  actionButton,
}: {
  isMobile: boolean;
  actionButton?: JSX.Element;
}) => {
  const pagination = document.getElementsByClassName('ant-pagination');

  if (pagination && pagination.length && isMobile) {
    const listItems = pagination[0].getElementsByTagName('li');
    const elementsArray = pagination && Array.from(listItems);

    const initialElement = elementsArray.find((element) => {
      return element.classList.contains('ant-pagination-total-text');
    });
    const targetElement = elementsArray.find((element) => {
      return element.classList.contains('ant-pagination-next');
    });

    const initialIndex =
      initialElement && elementsArray.indexOf(initialElement);
    const targetIndex = targetElement && elementsArray.indexOf(targetElement);

    initialIndex !== undefined &&
      targetIndex &&
      pagination[0].insertBefore(
        listItems[initialIndex],
        listItems[targetIndex + 1]
      );

    if (actionButton && !document.getElementsByClassName('mass-actions')[0]) {
      const tempContainer = document.createElement('li');

      tempContainer.classList.add('mass-actions_mobile');
      ReactDOM.render(actionButton, tempContainer);
      listItems[listItems.length - 1].after(tempContainer);
    }
  }

  const [mobilePagination] = document.getElementsByClassName(
    'mass-actions_mobile'
  );

  if (!isMobile && actionButton && mobilePagination) {
    mobilePagination.remove();
  }
};
